import styled from 'styled-components';

const ActionsDrawerWrapper = styled.div`
    .stacked-icons {
        font-size: 2rem;
        cursor: pointer;
        svg {
            &.base-icon {
                right: 0.5rem;
                top: 0.5rem;
                bottom: auto;
                left: auto;
            }
            &.stacked-icon {
                font-size: 1.25rem;
                top: 0;
                right: 0;
                bottom: auto;
                left: auto;
                --fa-secondary-opacity: 1;
                --fa-primary-opacity: 1;
                --fa-secondary-color: ${(props) => props.theme.PrimaryColor};
                --fa-primary-color: #fff;
            }
        }
    }
`;

const ActionItem = styled.div`
    display: flex;
    gap: 1rem;
    border-bottom: ${(props) => props.theme.DefaultBorder};
    padding: 1rem 0;
`;

const ActionItemIcon = styled.div`
    flex: 0 0 auto;
    width: 52px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
`;

const ActionItemBody = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

const ActionItemTitle = styled.div`
    font-weight: bold;
`;

const ActionItemDescription = styled.div`
    margin-top: 0.25rem;
`;

const ActionItemFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 0.75rem;
`;

const ExternalAccessInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.65rem;

    .section {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
    }

    .section + .section {
        border-top: ${(props) => props.theme.DefaultBorder};
        padding-top: 0.75rem;
    }

    .section-header {
        display: flex;
        align-items: baseline;
        gap: 0.4rem;
        flex-wrap: wrap;
    }

    .section-title {
        font-weight: bold;
    }

    .section-header .revoke-link {
        margin-left: auto;
    }

    .status-pill {
        display: inline-flex;
        align-items: center;
        border-radius: 999px;
        padding: 0.1rem 0.45rem;
        font-size: 0.75rem;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        background: ${(props) => props.theme.LighterBorderColor};
    }

    .status-pill.active {
        background: ${(props) => props.theme.PrimaryColor};
        color: #fff;
    }

    .status-pill.inactive {
        color: ${(props) => props.theme.TextColorMuted};
    }

    .status-pill.request-imported {
        background: ${(props) => props.theme.PrimaryColor};
        color: #fff;
    }

    .status-pill.request-pending {
        background: ${(props) => props.theme.DangerColor};
        color: #fff;
    }

    .status-pill.request-sent {
        background: ${(props) => props.theme.WarningColor};
        color: #fff;
    }

    .info-grid {
        display: grid;
        gap: 0.3rem;
    }

    .info-row {
        display: flex;
        align-items: baseline;
        gap: 0.4rem;
        flex-wrap: wrap;
    }

    .info-row.email-row {
        width: 100%;
    }

    .info-row.activation-row {
        width: 100%;
    }

    .info-row.email-row .value {
        flex: 1 1 auto;
        min-width: 0;
    }

    .info-row.activation-row .ant-btn-link {
        margin-left: auto;
    }

    .info-row.email-row .ant-btn-link {
        margin-left: auto;
    }

    .label {
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        color: ${(props) => props.theme.TextColorMuted};
    }

    .value {
        word-break: break-word;
    }

    .status-success {
        color: ${(props) => props.theme.SuccessColor};
        font-weight: 500;
    }

    .status-error {
        color: ${(props) => props.theme.DangerColor};
        font-weight: 500;
    }

    .request-row {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: nowrap;
        margin-top: 0.25rem;

        .ant-btn {
            flex: 0 0 auto;
            white-space: nowrap;
        }
    }

    .update-form-share {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
        margin-top: 0.4rem;
    }

    .update-form-help {
        max-width: 44rem;
        margin: 0;
        color: ${(props) => props.theme.SecondaryTextColor};
        font-size: 0.9rem;
        line-height: 1.45;
    }

    .update-form-share .copy-text-container {
        margin-top: 0.5rem;
        padding-left: 0.65rem;
        padding-right: 0.65rem;
    }

    .update-form-share .copy-text-container-text {
        min-width: 0;
    }

    .update-form-share .copy-text-container-text p {
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .update-form-actions {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }

    .update-request-email-button.ant-btn {
        font-weight: 400;
    }

    select {
        flex: 1 1 260px;
        min-width: 0;
        max-width: 320px;
        border: ${(props) => props.theme.DefaultBorder};
        border-radius: ${(props) => props.theme.BorderRadius};
        height: 32px;
        padding: 0 0.5rem;
        background: #fff;
    }
`;

export {
    ActionsDrawerWrapper,
    ActionItem,
    ActionItemIcon,
    ActionItemBody,
    ActionItemTitle,
    ActionItemDescription,
    ActionItemFooter,
    ExternalAccessInfo,
};
